import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {requestPasswordResetLink} from '../actions';
import {toggleDrawer} from '../../Layout/actions';
import LoadingSpinner from '../../Layout/components/LoadingSpinner';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../translations/translations_forgotpassword';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class ForgotPasswordDrawer extends Component {
    state = {
        errors: {},
        email: '',
        dialogSuccessOpen: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.errors !== this.props.errors) {
            this.setState({
                errors: this.props.errors,
            });
        }

        if (prevProps.auth.forgotPasswordSuccess !== this.props.auth.forgotPasswordSuccess) {
            if (this.props.auth.forgotPasswordSuccess) {
                this.props.toggleDrawer('forgotPassword', false);

                this.setState({
                    email: '',
                    dialogSuccessOpen: true,
                });
            }
        }
    }

    toggleDrawer = (drawer, open) => (e) => {
        e.preventDefault();

        this.props.toggleDrawer(drawer, open);
    };

    handleFormSubmit = e => {
        e.preventDefault();

        this.props.requestPasswordResetLink(this.state.email);
    };

    handleChange = name => e => {
        this.setState({
            [name]: e.target.value,
        });
    };

    handleCloseDialog = () => {
        this.setState({
            dialogSuccessOpen: false,
        });
    };

    render() {
        const {errors} = this.state;
        const {forgotPasswordLoading} = this.props.auth;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};

        return (
            <Fragment>
                <Drawer anchor="right" open={this.props.layout.forgotPasswordDrawerOpen} onClose={this.toggleDrawer('forgotPassword', false)} id="forgot-password-drawer" className="header-drawer" classes={{
                    paper: 'header-drawer-paper full',
                }}>
                    <div className="wrapper">
                        <div className="inner">
                            <div className="drawer-title">
                                <span className="section"><Translate id="auth_forgot_password.espace_personnel" /></span>
                                <h2 className="title"><Translate id="auth_forgot_password.title" /></h2>
                                <Button size="large" className="btn-close-drawer" onClick={this.toggleDrawer('forgotPassword', false)}>
                                    <CloseIcon className="m-icon"  />
                                </Button>
                                <div className="description">
                                    <p><Translate id="auth_forgot_password.description" /></p>
                                </div>
                            </div>
                            <form id="forgot-password-form" className="white-form" autoComplete="off" noValidate onSubmit={this.handleFormSubmit}>
                                <FormControl className="form-control" fullWidth={true} error={errorsData.email ? true : false}>
                                    <InputLabel htmlFor="email" className="form-label" style={{ fontSize: "20px" }}>Adresse email</InputLabel>
                                    <Input id="email" value={this.state.email} onChange={this.handleChange('email')} className="form-input" />
                                    {errorsData.email && (<FormHelperText id="email-error-text" className="form-helper">{this.props.translate('auth_forgot_password.' + errorsData.email)}</FormHelperText>)}
                                </FormControl>
                                <div className="row row-buttons">
                                    <div className="col col-12">
                                        {forgotPasswordLoading ? (
                                            <LoadingSpinner color="inherit" align="center" />
                                        ) : (
                                            <Button variant="contained" size="large" id="btn-submit" type="submit" disabled={forgotPasswordLoading}>
                                                <Translate id="auth_forgot_password.button_next" />
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Drawer>
                <Dialog
                    className="dialog-forgot-success"
                    open={this.state.dialogSuccessOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleCloseDialog}
                    aria-labelledby="dialog-forgot-success-title"
                    aria-describedby="dialog-forgot-success-description"
                >
                    <DialogTitle id="dialog-forgot-success-title">
                        <Translate id="auth_forgot_password.modal_title" />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="dialog-pending-signup-description">
                            <Translate id="auth_forgot_password.modal_description" />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseDialog} color="primary">
                            <Translate id="auth_forgot_password.button_close" />
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

ForgotPasswordDrawer.propTypes = {
    toggleDrawer: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.auth.forgotPasswordErrors,
    layout: state.layout,
});

export default connect(mapStateToProps, {requestPasswordResetLink, toggleDrawer})(withLocalize(ForgotPasswordDrawer));



// WEBPACK FOOTER //
// ./src/features/Auth/components/ForgotPasswordDrawer.js